module.exports = __webpack_public_path__ + "static/media/studentAffMembershipType.7640f521.png";